<template>
  <div>
    <div class="pdf-preview">
      <v-btn v-if="fullscreen" class="close-pdf-preview" color="white" icon text title="Close" @click="fullscreen = false">
        <v-icon>close</v-icon>
      </v-btn>
      <iframe v-if="fullscreen" class="pdf-preview-container" :src="url" scrolling="no" allowfullscreen webkitallowfullscreen />
    </div>
    <v-row>
      <v-col cols="12">
        <moves-filter />
      </v-col>
      <v-col cols="12">
        <moves-table
          :loading="loadingMoves"
          @openPDF="previewPDF"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import MovesTable from '@/components/moves/MovesTable';
  import MovesFilter from '@/components/moves/MovesFilter';
  import {mapActions, mapGetters} from 'vuex';
  import * as actions from '@/store/actions.type';

  export default {
    name: 'Moves',
    components: {
      MovesFilter,
      MovesTable,
    },
    data: () => ({
      url: undefined,
      fullscreen: false,
    }),
    computed: {
      ...mapGetters([
        'loadingMoves'
      ]),
    },
    watch: {
      $route() {
        this.fetchMovesWithUrlParams();
      }
    },
    destroyed() {
      this.resetDeviceFilterAction()
    },
    mounted() {
      this.fetchMovesWithUrlParams();
    },
    methods: {
      ...mapActions({
        fetchMovesAction: actions.FETCH_MOVES,
        resetDeviceFilterAction: actions.RESET_DEVICE_FILTER
      }),
      previewPDF(value) {
        this.fullscreen = true;
        this.url = value;
      },
      fetchMovesWithUrlParams() {
        if (this.$route.query.name) {
          this.fetchMovesAction({
            name: this.$route.query.name,
            moveStatusType: null
          });
        }
      }
    }
  };
</script>

<style scoped>

</style>